import noUiSlider from 'nouislider';
import qs from 'qs';
import gsap from 'gsap';
import axios from 'axios';
import isEmail from 'validator/lib/isEmail';
import isMobilePhone from 'validator/lib/isMobilePhone';

class Alert {
    constructor(parentClass, triggerClass, triggerFiltersClass, action) {
        this.containerClass = parentClass;
        if (document.querySelector(this.containerClass)) {
            this.triggerClass = triggerClass;
            this.action = action;
            this.triggerFiltersClass = triggerFiltersClass;
            this.step1Class = `${this.containerClass} .alert__step_1`;
            this.step2Class = `${this.containerClass} .alert__step_2`;
            this.closeClass = `${this.containerClass} .alert__close`;
            this.nextStepClass = `${this.containerClass} .button__nextstep`;
            this.backClass = `${this.containerClass} .alert__back`;
            this.formClass = `${this.containerClass} .alert__form`;
            this.logClass = `${this.containerClass} .alert__log`;
            this.submitBtnClass = `${this.containerClass} .alert__submit`;
            this.emailInputClass = `${this.containerClass} .alert__email`;
            this.lastnameInputClass = `${this.containerClass} .alert__lastname`;
            this.firstnameInputClass = `${this.containerClass} .alert__firstname`;
            this.contactedInputClass = `${this.containerClass} .alert__contacted`;
            this.phoneInputClass = `${this.containerClass} .alert__phone`;
            this.fieldsClass = `${this.containerClass} .alert__field`;
            this.config = ALERTS.data; // eslint-disable-line
            this.step = 1;

            this.priceRange = null;
            this.kmRange = null;
            this.selectBrand = document.querySelector(`${this.containerClass} .alert_brand`);
            this.selectModele = document.querySelector(`${this.containerClass} .alert_modele`);

            this.intColor = document.getElementById('alertsearch__intcolor');
            this.extColor = document.getElementById('alertsearch__extcolor');
            this.intFinishField = document.getElementById('alertsearch_finish');
            this.yearMinField = document.getElementById('alertsearch_year_min');
            this.yearMaxField = document.getElementById('alertsearch_year_max');
            this.alertDetails = document.getElementById('alertsearch__details');


            this.container = document.querySelector(this.containerClass);
            this.step1 = document.querySelector(this.step1Class);
            this.step2 = document.querySelector(this.step2Class);
            this.close = document.querySelector(this.closeClass);
            this.nextStep = document.querySelector(this.nextStepClass);
            this.back = document.querySelector(this.backClass);
            this.form = document.querySelector(this.formClass);
            this.log = document.querySelector(this.logClass);
            this.fields = document.querySelectorAll(this.fieldsClass);
            this.submitBtn = document.querySelector(this.submitBtnClass);
            this.emailInput = document.querySelector(this.emailInputClass);
            this.lastnameInput = document.querySelector(this.lastnameInputClass);
            this.firstnameInput = document.querySelector(this.firstnameInputClass);
            this.contactedInput = document.querySelector(this.contactedInputClass);
            this.phoneInput = document.querySelector(this.phoneInputClass);
            this.isPhoneRequired = false;
            if (parentClass === '.alert_search') {
                this.isPhoneRequired = true;
            }
            this.trigger = document.querySelector(this.triggerClass);
            if (this.triggerFiltersClass !== '') {
                this.triggerFilters = document.querySelector(this.triggerFiltersClass);
            }

            this.filters = document.querySelector('#filters');

            this.init();
        }
    }

    init() {
        this.buildRangeSliders();
        this.initEvents();
    }

    initEvents() {
        if (this.trigger) {
            this.trigger.addEventListener('click', () => {
                this.prefill();
                this.openAlert();
            });
        }

        if (this.triggerFilters) {
            this.triggerFilters.addEventListener('click', (e) => {
                e.preventDefault();
                this.prefill();
                this.openAlert();
            });
        }
        this.close.addEventListener('click', () => {
            this.closeAlert();
        });
        this.nextStep.addEventListener('click', (e) => {
            e.preventDefault();
            this.goToStep(2);
        });
        this.back.addEventListener('click', (e) => {
            e.preventDefault();
            this.goToStep(1);
        });
        this.form.addEventListener('submit', (e) => {
            e.preventDefault();
            this.validateFields();
            this.submit();
        });

        if (this.contactedInput) {
            this.contactedInput.addEventListener('change', (e) => {
                if (e.target.checked) {
                    this.isPhoneRequired = true;
                    this.phoneInput.parentElement.style.display = 'block';
                } else {
                    this.isPhoneRequired = false;
                    this.phoneInput.parentElement.style.display = 'none';
                }
            });
        }

        Array.from(this.fields).forEach((field) => {
            field.addEventListener('blur', () => {
                this.validateField(field);
            });
        });
    }

    validateFields() {
        let canSend = true;
        Array.from(this.fields).forEach((field) => {
            const isValid = this.validateField(field);
            if (!isValid) {
                canSend = false;
            }
        });
        return canSend;
    }

    validateField(field) {
        if (field.value === '') {
            if ((field.name === 'alert_phone' && !this.isPhoneRequired)
                || field.name === 'alert_details') {
                return true;
            }

            // eslint-disable-next-line
            field.parentElement.querySelector('.input__message').innerHTML = 'Ce champ est obligatoire.';
            return false;
        } else { // eslint-disable-line
            if (field.type === 'email') { // eslint-disable-line
                if (!isEmail(field.value)) {
                    // eslint-disable-next-line
                    field.parentElement.querySelector('.input__message').innerHTML = `L'adresse e-mail n'est pas valide.`;
                    return false;
                } else { // eslint-disable-line
                    // eslint-disable-next-line
                    field.parentElement.querySelector('.input__message').innerHTML = '';
                }
            } else if (field.name === 'alert_phone') {
                if (this.isPhoneRequired || field.value !== '') {
                    if (!isMobilePhone(field.value, ['fr-FR'], false)
                    && !this.validateFrenchPhone(field.value)) {
                        // eslint-disable-next-line
                        field.parentElement.querySelector('.input__message').innerHTML = `Le numéro de téléphone n'est pas valide.`;
                        return false;
                    } else { // eslint-disable-line
                        // eslint-disable-next-line
                        field.parentElement.querySelector('.input__message').innerHTML = '';
                    }
                }
            } else {
                // eslint-disable-next-line
                field.parentElement.querySelector('.input__message').innerHTML = '';
            }
        }
        return true;
    }

    validateFrenchPhone(number) { // eslint-disable-line
        const regex = new RegExp(/^(01|02|03|04|05|06|08)[0-9]{8}$/gi);

        // Definition de la variable booleene match
        let match = false;

        // Test sur le motif
        if (regex.test(number)) {
            match = true;
        } else {
            match = false;
        }

        // On renvoie match
        return match;
    }

    openAlert() {
        const tl = gsap.timeline();
        tl.to(this.container, {
            duration: 1,
            yPercent: -100,
        });
    }

    goToStep(step) {
        const tl = gsap.timeline();
        if (step === 2) {
            tl.to(this.step2, {
                yPercent: -100,
            }).to(this.close, {
                duration: 1,
                color: '#ffffff',
            }).set(this.back, {
                display: 'block',
            }).to(this.back, {
                duration: 1,
                opacity: 1,
            }, '-=1');
            this.step = 2;
        } else if (step === 1) {
            tl.to(this.step2, {
                duration: 1,
                yPercent: 0,
            }).to(this.close, {
                duration: 1,
                color: '#000000',
            }).set(this.back, {
                display: 'none',
            }).to(this.back, {
                duration: 1,
                opacity: 0,
            }, '-=1');
            this.step = 1;
        }
    }

    closeAlert() {
        this.reinitForm();
        const tl = gsap.timeline();
        if (this.step === 1) {
            tl.to(this.container, {
                duration: 1,
                yPercent: 0,
            });
        } else if (this.step === 2) {
            tl.to(this.container, {
                duration: 1,
                yPercent: 0,
            }).set(this.step2, {
                yPercent: 0,
            }).set(this.close, {
                color: '#000000',
            });
        }
    }

    buildRangeSliders() {
        if (document.querySelector(this.containerClass)) {
            const price = document.querySelector(`${this.containerClass} .alert__price`);
            const priceMin = document.querySelector(`${this.containerClass} .alert__price_min`);
            const priceMax = document.querySelector(`${this.containerClass} .alert__price_max`);
            this.priceRange = noUiSlider.create(price, {
                range: {
                    min: parseInt(this.config.price.min, 10),
                    max: parseInt(this.config.price.max, 10),
                },
                start: [
                    parseInt(this.config.price.min, 10),
                    parseInt(this.config.price.max, 10),
                ],
                step: 1000,
                margin: 5000,
                connect: true,
            });

            price.noUiSlider.on('update', (values) => {
                priceMin.innerHTML = `${new Intl.NumberFormat().format(values[0])}€`;
                priceMax.innerHTML = `${new Intl.NumberFormat().format(values[1])}€`;
            });

            const km = document.querySelector(`${this.containerClass} .alert__km`);
            const kmMin = document.querySelector(`${this.containerClass} .alert__km_min`);
            const kmMax = document.querySelector(`${this.containerClass} .alert__km_max`);
            this.kmRange = noUiSlider.create(km, {
                range: {
                    min: parseInt(this.config.km.min, 10),
                    max: parseInt(this.config.km.max, 10),
                },
                start: [
                    parseInt(this.config.km.min, 10),
                    parseInt(this.config.km.max, 10),
                ],
                step: 5000,
                margin: 10000,
                connect: true,
            });
            km.noUiSlider.on('update', (values) => {
                kmMin.innerHTML = `${new Intl.NumberFormat().format(values[0])}km`;
                kmMax.innerHTML = `${new Intl.NumberFormat().format(values[1])}km`;
            });
        }
    }

    reinitForm() {
        this.priceRange.set(
            [
                parseInt(this.config.price.min, 10),
                parseInt(this.config.price.max, 10),
            ],
        );
        this.kmRange.set(
            [
                parseInt(this.config.km.min, 10),
                parseInt(this.config.km.max, 10),
            ],
        );
        // this.selectBrand.selectedIndex = 0;
        // this.selectModele.selectedIndex = 0;
        this.emailInput.value = '';
        this.lastnameInput.value = '';
        this.firstnameInput.value = '';
        if (this.contactedInput) {
            this.contactedInput.checked = false;
        }
        this.phoneInput.value = '';
        this.log.innerHTML = '';
        this.submitBtn.removeAttribute('disabled');
    }

    unlockSubmit(email) {
        if (!isEmail(email)) {
            if (this.submitBtn.getAttribute('disabled') !== 'disabled') {
                this.submitBtn.setAttribute('disabled', 'disabled');
            }
        } else {
            this.submitBtn.removeAttribute('disabled');
        }
    }

    submit() {
        this.submitBtn.setAttribute('disabled', 'disabled');
        let data = {
            brand: this.selectBrand.value,
            modele: this.selectModele.value,
            fuel: this.getCheckedBoxes(`${this.containerClass} [name="alert_fuel"]`),
            gearbox: this.getCheckedBoxes(`${this.containerClass} [name="alert_gearbox"]`),
            km: this.kmRange.get(),
            price: this.priceRange.get(),
            email: this.emailInput.value,
            lastname: this.lastnameInput.value,
            firstname: this.firstnameInput.value,
            phone: this.phoneInput.value,
            action: this.action,
        };

        if (this.action === 'add_alert_search') {
            data = {
                ...data,
                intcolor: this.intColor.value,
                extcolor: this.extColor.value,
                intfinish: this.intFinishField.options[this.intFinishField.selectedIndex].text,
                yearmin: this.yearMinField.options[this.yearMinField.selectedIndex].text,
                yearmax: this.yearMaxField.options[this.yearMaxField.selectedIndex].text,
                details: this.alertDetails.value,
            };
        }

        if (this.validateFields()) {
            this.log.innerHTML = '';
            axios.post(
                GLOBALS.FORM_ACTION, // eslint-disable-line
                qs.stringify(data),
            ).then((response) => {
                this.log.classList.remove('form__success');
                if (response.data.res === 'success') {
                    this.log.classList.add('form__success');
                    const redirect = this.action === 'add_alert' ? this.config.redirect.alert : this.config.redirect.search;
                    if (typeof redirect !== 'undefined' && redirect !== '') {
                        window.location.href = redirect;
                    } else {
                        this.log.innerHTML = this.action === 'add_alert' ? 'Votre alerte a bien été ajoutée.' : 'Votre recherche personnalisée a bien été ajoutée.';
                        setTimeout(() => {
                            this.closeAlert();
                            this.reinitForm();
                        }, 2000);
                    }
                } else if (response.data.res === 'error') {
                    this.log.innerHTML = 'Une erreur est survenue. Si le problème persiste merci de nous contacter.';
                } else if (response.data.res === 'exist') {
                    this.log.innerHTML = 'Vous avez déjà crée une alerte avec ces critères.';
                } else if (response.data.res === 'over') {
                    this.log.innerHTML = 'Vous ne pouvez avoir que 10 alertes simultanéement.';
                }
            }).catch(error => Promise.reject(error));
        } else {
            this.log.innerHTML = 'Le formulaire contient une ou plusieurs erreurs.';
        }
        this.submitBtn.removeAttribute('disabled');
    }

    prefill() {
        if (this.filters) {
            const budget = document.querySelector('.filters__budget');
            const km = document.querySelector('.filters__km');
            const data = {
                budget: {
                    value: budget.noUiSlider.get().map(value => parseInt(value, 10)).join('-'),
                    selector: `${this.containerClass} .alert__price`,
                    type: 'range',
                },
                km: {
                    value: km.noUiSlider.get().map(value => parseInt(value, 10)).join('-'),
                    selector: `${this.containerClass} .alert__km`,
                    type: 'range',
                },
                vitesse: {
                    value: this.getCheckedBoxes('#filters [name="vitesse"]'),
                    selector: `${this.containerClass} [name="alert_gearbox"]`,
                    type: 'check',
                },
                energies: {
                    value: this.getCheckedBoxes('#filters [name="energies"]'),
                    selector: `${this.containerClass} [name="alert_fuel"]`,
                    type: 'check',
                },
            };

            Object.values(data).forEach((criteria) => {
                if (criteria.value !== '' && criteria.value !== null) {
                    const terms = criteria.value.split('-');
                    switch (criteria.type) {
                    case 'check':
                        Array.from(document.querySelectorAll(criteria.selector))
                            .forEach((checkbox) => {
                                if (terms.includes(checkbox.value)) {
                                    checkbox.checked = true; // eslint-disable-line
                                }
                            });
                        break;
                    case 'range':
                        document.querySelector(criteria.selector).noUiSlider.set([
                            parseInt(terms[0], 10),
                            parseInt(terms[1], 10),
                        ]);
                        break;
                    default:
                        break;
                    }
                }
            });
        }
    }

    getCheckedBoxes(checkbox) { // eslint-disable-line
        const checkboxes = document.querySelectorAll(checkbox);
        const checkboxesChecked = [];
        // loop over them all
        for (let i = 0; i < checkboxes.length; i++) { // eslint-disable-line
            // And stick the checked ones onto an array...
            if (checkboxes[i].checked) {
                checkboxesChecked.push(checkboxes[i].value);
            }
        }
        // Return the array if it is non-empty, or null
        return checkboxesChecked.length > 0 ? checkboxesChecked.join('-') : null;
    }
}

export default Alert;
